import getUserProperties from "@/users/getUserProperties";
import useUser from "@/users/useUser";

const useCanViewAdminConsole = () => {
  const { data: user } = useUser();
  const { hasFeature } = getUserProperties(user);

  return hasFeature("can_view_admin_console");
};

export default useCanViewAdminConsole;
